<template>
  <div class="box">
    <!-- 获取到数据 -->
    <div class="header" v-if="title && iconImg != undefined">
      <div class="left">
        <img :src="iconImg" alt="" />
        <p>{{ title }}</p>
      </div>
      <div class="right">
        {{ rightNum }}
      </div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: "vistor-table",
  props: {
    title: String,
    iconImg: String,
    rightNum: String,
  },
};
</script>

<style lang="scss" scoped>
.box::before {
  content: "";
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(5px);
  opacity: 0.6;
  background: inherit;
}
.box {
  min-width: 300px;
  height: 100%;
  color: #fff;
  background: linear-gradient(
    179.85deg,
    rgba(255, 255, 255, 0.13) 0.13%,
    rgba(0, 0, 0, 0) 49.7%
  );
  position: relative;
  .header {
    padding-top: 10px;
  }
  .header,
  .header2 {
    padding-left: 10px;

    display: flex;
    align-items: center;

    &::before {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      width: 6px;
      height: 6px;
      border-top: 1px solid #fff;
      border-left: 1px solid #fff;
    }

    &::after {
      content: "";
      position: absolute;
      top: -1px;
      right: -1px;
      width: 6px;
      height: 6px;
      border-right: 1px solid #fff;
      border-top: 1px solid #fff;
    }

    .left {
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 30px;
      }

      p {
        font-weight: 700;
        font-size: 24px;
        letter-spacing: 0.1em;
        margin-left: 10px;
      }
    }

    .right {
      position: absolute;
      right: 37px;
      text-align: right;
      font-weight: 500;
      font-size: 48px;
      line-height: 55px;
      font-family: "dina";
      color: #2d82ff;
    }
  }

  .line::before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: -1px;
    width: 6px;
    height: 6px;
    border-bottom: 1px solid #fff;
    border-left: 1px solid #fff;
  }

  .line::after {
    content: "";
    position: absolute;
    bottom: -1px;
    right: -1px;
    width: 6px;
    height: 6px;
    border-bottom: 1px solid #fff;
    border-right: 1px solid #fff;
  }
}
</style>
